<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        {{ action }} Re-engagement Audience
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#"><i class="fa fa-dashboard"></i> Home</a>
        </li>
        <li class="active">Audience Builder</li>
      </ol>
    </section>
    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="col-xs-12 col-md-12 col-lg-12">
                <Form/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.row -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
import Form from './form'

export default {
  name: 'audience-builder',
  components: {
    Form
  },
  data () {
    return {
      action: 'Create'
    }
  },
  mounted () {
    if (this.$route.query.queryId) {
      this.action = 'Update'
    }
  }
}
</script>

<style scoped>
.value {
  font-weight: bold;
}
.box-body {
  min-height: calc(100vh - 171px);
}
.form-loader img {
  width: 30px;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// index.vue?6af44960